import * as fromRoot from '../../shared/reducers';
import {OrdersListReducer, ordersListSelectors, OrdersListState} from './orders-list';
import {ActionReducerMap, createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import * as _ from 'lodash';
import {OrderFilter} from '../models/order-filter';
import {Order, SelectedItem} from '../models/order';
import {OrderReducer, orderSelectors, OrderState} from './order';
import {MemoizedSelectorWithProps} from '@ngrx/store/src/selector';
import {OrderItem} from '../models/order-item';
import {OrderSelectedState, OrdersSelectedReducer, ordersSelectedSelectors} from './orders-selected';
import {ShippingDHLsState, ShippingsDHLReducer, shippingsDHLSelectors} from '../../order/reducers/shipping';
import {RatingDHLsState, ratingDHLReducer, ratingDHLSelectors} from './dhlrating';
import {PdfAzureState, pdfAzureReducer, pdfAzureSelectors} from '../../order/reducers/azurepdf';
import {FamiliesReducer, familiesSelectors, FamiliesState} from './player-adoption-families';
import {ConceptsOrderReducer, conceptsOrderSelectors, ConceptsOrderState} from './concept-order';
import {Concept, ConceptOrder} from '../../shared/models/concept';


export interface OrdersState {
  order: OrderState;
  ordersList: OrdersListState;
  ordersSelected: OrderSelectedState;
  shippingList: ShippingDHLsState;
  ratinglist: RatingDHLsState;
  pdflist: PdfAzureState;
  families: FamiliesState;
  conceptsOrder: ConceptsOrderState;
}

export interface AppState extends fromRoot.AppState {
  orders: OrdersState;
}

export const reducers: ActionReducerMap<OrdersState> = {
  order: OrderReducer,
  ordersList: OrdersListReducer,
  ordersSelected: OrdersSelectedReducer,
  shippingList: ShippingsDHLReducer,
  ratinglist: ratingDHLReducer,
  pdflist : pdfAzureReducer,
  families : FamiliesReducer,
  conceptsOrder : ConceptsOrderReducer
};

const getOrderState = createFeatureSelector('orders');

const rootSelectors = {

  order: createSelector(getOrderState, (state: OrdersState) => _.get(state, 'order')),
  ordersList: createSelector(getOrderState, (state: OrdersState) => _.get(state, 'ordersList')),
  ordersSelected: createSelector(getOrderState, (state: OrdersState) => _.get(state, 'ordersSelected')),
  shippingList: createSelector(getOrderState, (state: OrdersState) => _.get(state, 'shippingList')),
  ratinglist: createSelector(getOrderState, (state: OrdersState) => _.get(state, 'ratinglist')),
  pdflist: createSelector(getOrderState, (state: OrdersState) => _.get(state, 'pdflist')),
  families: createSelector(getOrderState, (state: OrdersState) => _.get(state, 'families')),
  conceptsOrder: createSelector(getOrderState, (state: OrdersState) => _.get(state, 'conceptsOrder')),
};

export interface Selectors {
  getFilter: MemoizedSelector<AppState, OrderFilter | string | number>;
  getQuickSearch: MemoizedSelector<AppState, string>;
  getOrderBy: MemoizedSelector<AppState, string>;
  getOrder: MemoizedSelector<AppState, Order>;
  getOrders: MemoizedSelector<AppState, OrderItem[]>;
  getOrderByUuid: MemoizedSelectorWithProps<AppState, string, OrderItem>;
  getOrdersCount: MemoizedSelector<AppState, number>;
  getOrdersSelected: MemoizedSelector<AppState, Order[]>;
  getPageSize: MemoizedSelector<AppState, number>;
  getPage: MemoizedSelector<AppState, number>;
  getSelectedOrders: MemoizedSelector<AppState, SelectedItem[]>;
  getShowFilter: MemoizedSelector<AppState, boolean>;
  // tslint:disable-next-line:no-any
  getShipping: MemoizedSelector<AppState, any[]>;
  // tslint:disable-next-line:no-any
  getRatingReturn: MemoizedSelector<AppState, any[]>;
  // tslint:disable-next-line:no-any
  getRating: MemoizedSelector<AppState, any[]>;
  // tslint:disable-next-line:no-any
  getFamilies: MemoizedSelector<AppState, any[]>;
  getPdf: MemoizedSelector<AppState, string>;
  getConceptsOrder: MemoizedSelector<AppState,  ConceptOrder[]>;
}

export const selectors: Selectors = {
  getFilter: createSelector(rootSelectors.ordersList, ordersListSelectors.filter),
  getQuickSearch: createSelector(rootSelectors.ordersList, ordersListSelectors.quickSearch),
  getOrderBy: createSelector(rootSelectors.ordersList, ordersListSelectors.orderBy),
  getOrder: createSelector(rootSelectors.order, orderSelectors.order),
  getOrders: createSelector(rootSelectors.ordersList, ordersListSelectors.array),
  getOrderByUuid: createSelector(rootSelectors.ordersList, (state: OrdersListState, props: string) => ordersListSelectors.selectOrderByUuid(state, props)),
  getOrdersCount: createSelector(rootSelectors.ordersList, ordersListSelectors.count),
  getOrdersSelected: createSelector(rootSelectors.ordersSelected, ordersSelectedSelectors.ordersSelected),
  getPageSize: createSelector(rootSelectors.ordersList, ordersListSelectors.pageSize),
  getPage: createSelector(rootSelectors.ordersList, ordersListSelectors.page),
  getSelectedOrders: createSelector(rootSelectors.ordersList, ordersListSelectors.selectedOrder),
  getShowFilter: createSelector(rootSelectors.ordersList, ordersListSelectors.showFilter),
  getShipping: createSelector(rootSelectors.shippingList, shippingsDHLSelectors.array),
  getRating: createSelector(rootSelectors.ratinglist, ratingDHLSelectors.array),
  getRatingReturn: createSelector(rootSelectors.ratinglist, ratingDHLSelectors.arrayReturn),
  getFamilies: createSelector(rootSelectors.families, familiesSelectors.array),
  getPdf: createSelector(rootSelectors.pdflist, pdfAzureSelectors.url),
  getConceptsOrder: createSelector(rootSelectors.conceptsOrder, conceptsOrderSelectors.array),
};
